<template>
  <Card :title="name">
    <div v-for="(d, i) in appendix" :key="i">
      <Divider> 记录{{ i + 1 }}</Divider>
      <Field
        v-model="d.projectName"
        label="培训项目名称"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.time"
        label="培训时间"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.studyTime"
        label="培训学时"
        :readonly="readonly"
        placeholder="请输入"
      />
      <div
        style="padding-left: 16px;display: flex;justify-content: space-between;align-items: center;height: 44px"
      >
        请选择培训形式
        <RadioGroup v-model="d.studyType" direction="horizontal">
          <Radio name="报告讲座">报告讲座</Radio>
          <Radio name="操作示范">操作示范</Radio>
        </RadioGroup>
      </div>
      <div
        style="padding-left: 16px;display: flex;justify-content: space-between;align-items: center;height: 44px"
      >
        请选择培训层次
        <RadioGroup v-model="d.studyLevel" direction="horizontal">
          <Radio name="院级">院级</Radio>
          <Radio name="科级">科级</Radio>
        </RadioGroup>
      </div>
      <Field
        v-model="d.teacher"
        label="授课人签字"
        :readonly="readonly"
        placeholder="请输入"
      />
      <div class="action" v-if="!readonly">
        <VanBtn
          round
          block
          @click="delRecord(i)"
          :disabled="appendix.length === 1"
          type="danger"
          color="#EA514B"
          size="small"
          >删除</VanBtn
        >
      </div>
    </div>
    <div class="action" v-if="!readonly">
      <VanBtn round type="primary" size="small" @click="addRecord()"
        >添加</VanBtn
      >
    </div>
  </Card>
</template>
<script>
import { Field, Button as VanBtn, Divider, RadioGroup, Radio } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "Appendix",
  props: {
    readonly: Boolean
  },
  data: function() {
    return {
      name: "附件：讲座及集中操作培训记录",
      appendix: [
        {
          projectName: "",
          time: "",
          studyTime: "",
          studyType: "",
          studyLevel: "",
          teacher: ""
        }
      ]
    };
  },
  methods: {
    addRecord() {
      this.appendix.push({
        projectName: "",
        time: "",
        studyTime: "",
        studyType: "",
        studyLevel: "",
        teacher: ""
      });
    },
    delRecord(index) {
      if (this.appendix.length === 1) {
        return;
      }
      this.appendix.splice(index, 1);
    }
  },
  components: { Card, Field, VanBtn, Divider, RadioGroup, Radio }
};
</script>
<style lang="scss" scoped>
.action {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  button {
    width: 36%;
  }
}
</style>
